import { render, staticRenderFns } from "./AlmoxarifadoForm.vue?vue&type=template&id=a2aa08ca"
import script from "./AlmoxarifadoForm.vue?vue&type=script&lang=js"
export * from "./AlmoxarifadoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports